import Vue from 'vue'
import Router from 'vue-router'
import routes from './youzheng' // 邮政活动；首页
import xiqueClinc from './xiqueClinc' // 喜鹊医生
import pintuan from './pintuan' // 拼团
import yuangongquan from './yuangongquan' // 邮工圈
import zhigongxiaojia from './zhigongxiaojia' // 职工小家
import mamixiaowu from './mamixiaowu' // 妈咪小屋
import shuping from './shuping' // 书评
import mall2 from './mall' // 新积分商城——评价、投诉
import mallWechatPay from './mallWechatPay' // 积分商城新增微信支付
import pengchengxinli from './pengchengxinli' // 朋橙心理
import chunjie from './chunjie' // 春节活动——集福卡
import Config from '@/config'
import store from '@/store'
import Storage from '@/storage'
import lalisai from './lalisai' // 答题拉力赛
import jianianhua from './jianianhua' // 嘉年华
import zhibo from './zhibo' // 直播
import {
  getRequest,
  isIos,
  funcUrlDel
} from '@/libs/utils.js'
import {
  getUserinfo,
  getUserAccount
} from '@/api/user.js'
import yiliaohuzhu from './yiliaohuzhu' // 医疗互助
Vue.use(Router)

const router = new Router({
  base: process.env.NODE_ENV === 'production' ? 'youzheng/wechat/youzheng/' : '/',
  // youzheng/wechat/youzheng/
  mode: 'history',
  routes: [...routes, ...xiqueClinc, ...pintuan, ...yuangongquan, ...zhigongxiaojia, ...pengchengxinli, ...yiliaohuzhu, ...mamixiaowu, ...chunjie, ...shuping, ...lalisai, ...jianianhua, ...mall2, ...zhibo, ...mallWechatPay]
})

router.beforeEach((to, from, next) => {
  let CODE = Storage.get('CODE')
  let userid = Storage.get('userid') /* #TODO 开发环境时注释，生产环境打包时取消注释 */
  // let userid = 'Yue' // 测试环境的开发userid
  // let userid = '5423c633bb22914d2f2b642aab1bf87a' // 测试
  // let userid = 'thr' // 测试
  // let userid = 'zhangyuefeng' /* 正式环境的开发userid #TODO 生产环境打包时此代码注释 */
  // let userid = 'yemingxu' // 正式
  // let userid = 'hywlx' // 正式
  // let userid = 'jiangzefang' // 正式
  // let userid = 'ZhangHaiYing' // 正式
  // let userid = 'daihongjie' // 正式
  // let userid = 'HZ1231' // 正式
  // let userid = 'tianhuarong' // 正式
  // Storage.set('userid', userid)
  const getWechatSignUrl = (to) => {
    if (isIos()) {
      return window.location.href
    } else {
      return Config.baseDeaultUrl + to.fullPath
    }
  }
  store.commit('setWechatSignUrl', getWechatSignUrl(to))
  // 得到用户信息
  const getAccount = () => {
    getUserAccount({
      userid: userid
    }).then(res => {
      if (res.status === 'suc') {
        Storage.set('myaccountid', res.returnValue.accountid)
        store.commit('setAccountid', res.returnValue.accountid)
        store.commit('setUserId', userid)
        store.commit('setPersonObj', {
          accountsexid: res.returnValue.accountsexid,
          accountsexidNAME: res.returnValue.accountsexidNAME,
          acctname: res.returnValue.acctname,
          birthday: res.returnValue.birthday,
          cityid: res.returnValue.cityid,
          cityidNAME: res.returnValue.cityidNAME,
          countyid: res.returnValue.countyid,
          countyidNAME: res.returnValue.countyidNAME,
          iconimg: res.returnValue.iconimg,
          iconimgPATH: res.returnValue.iconimgPATH,
          idcard: res.returnValue.idcard,
          mobile: res.returnValue.mobile,
          provinceid: res.returnValue.provinceid,
          provinceidNAME: res.returnValue.provinceidNAME,
          unitname: res.returnValue.unitname,
          isqyb: res.returnValue.isqyb,
          accounttype: res.returnValue.accounttype,
          isAdmin: res.returnValue.isAdmin // 邮工圈使用
        })
        next()
      }
    })
  }
  // 得到企业用户信息
  const getuser = () => {
    Storage.set('token', '')
    getUserinfo({
      code: getRequest().code
    }).then(res => {
      if (res.status === 'suc') {
        if (!res.returnValue.userid) {
          if (to.name === 'yzDetail') { // 如果是新闻详细页面，非企业用户也可以打开
            Storage.set('CODE', '')
            next()
          } else {
            Vue.$vux.alert.show({
              title: '请求出错',
              content: '您不是该企业用户成员'
            })
          }
        } else {
          userid = res.returnValue.userid
          Storage.set('userid', userid)
          Storage.set('token', res.returnValue.token)
          getAccount()
        }
      }
    })
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // if (
  //   (from.name === 'myMailDetailCommon' && to.name === 'myMailCommon')
  // ) {
  //   to.meta.keepAlive = true
  // } else {
  //   to.meta.keepAlive = false
  // }
  if (to.name !== 'yzQuestion' && to.name !== 'yzQuestionAsk') {
    if (getRequest().code && CODE !== getRequest().code) {
      Storage.set('CODE', getRequest().code)
      getuser()
    } else if (typeof (userid) === 'undefined' || userid === '') {
      // getAccount()
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + Config.appid + '&redirect_uri=' + funcUrlDel('code') + '/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
    } else {
      getAccount()
    }
  } else {
    next()
  }
})

export default router
